import "./DeviceTile.scss";

import { Transition } from "@headlessui/react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ButtonLink } from "@/components/Interface/Button/Button";
import { FCC } from "@/types.ts";

interface DeviceTileProps {
  navigationTarget?: string;
  disableForPending?: boolean;
  className?: string;
  buttonText?: string;
}
interface TestableDeviceTileProps extends DeviceTileProps {
  dataTestid: string;
}

export const DeviceTile: FCC<TestableDeviceTileProps> = ({
  navigationTarget,
  children,
  dataTestid,
  className,
  buttonText,
}) => {
  const { t } = useTranslation(["portal", "translation"]);

  return (
    <div
      data-testid="device-tile"
      className={clsx(className, "tile-container")}
    >
      <Transition
        as="div"
        appear={true}
        show={true}
        enter="transition-opacity ease-linear duration-150"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-linear duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div data-testid={dataTestid} className="tile">
          <div className="content-container">
            {children}
            {navigationTarget && (
              <ButtonLink
                className="mt-auto"
                variant="primary"
                fullWidth
                to={navigationTarget}
              >
                {buttonText || t("translation:Common.label.manage")}
              </ButtonLink>
            )}
          </div>
        </div>
      </Transition>
    </div>
  );
};
